import React,{Fragment, PureComponent, } from 'react'
import {Image, message, Button,Modal,Row} from 'antd';
import PropTypes from 'prop-types';
import Lang from "@/components/Lang/Lang";
import {isEmpty } from '@utils/utils';
import ShipperManagementAction from "../ShipperManagement.action";
import {EyeOutlined } from "@ant-design/icons";
import './Index.less';

const ImagePreviewGroup= Image.PreviewGroup;
/**
 * 查看装柜图片 点击打开，幻灯片模式，
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 *
 *
 **/
class CabinetPicturePreview extends PureComponent {
    static propTypes = {
        item: PropTypes.object.isRequired,
    }
    static defaultProps = {
        item: {},
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            visibleModal:false,
            list: [],
        }
    }
    /**
     * 查看装柜图片
     * */
    viewStickerPictures(poItem={}){
        if(poItem.containerId){
            this.props.loading(true);
            const postData = {
                containerId:poItem.containerId,
            }
            ShipperManagementAction.getLoadContainerPic(postData).then(res=>this.handleGetPicturesRes(res.data)).catch(err=>this.handleGetPicturesRes(err));
        }else message.warning(Lang({
            id:'CaoZuoShiBai',
            default:'操作失败'
        }));
    }
    handleGetPicturesRes(res){
        this.props.loading(false);
        const {success,valid,models=[]} = res;
        if(success&&valid){
           if(models.length>0){
               this.setVisible(true,models)
           }else message.warning(Lang({id:'ZanWeiShangChuan',default: '暂未上传'}));
        }else if(res.message){
            message.warning(res.message);
        }else message.warning(Lang({
            id:'CaoZuoShiBai',
            default:'操作失败'
        }));
    }
    /**
     * 设置 预览
     */
    setVisible(flag,models=[],current=0){
        this.setState({
            visibleModal:flag,
            list:models,
            current:current
        })
    }
    /**
     * 下载装箱单图片
     * */
    downloadPic(containerId){
        const postData = {
            containerId:containerId,
        }
        ShipperManagementAction.downloadLoadContainerPic(postData).then(res=>this.handleDownLoadRes(res.data)).catch(err=>this.handleDownLoadRes(err));
    }
    handleDownLoadRes(res){
        const {success,valid,model} = res;
        if(success&&valid){
            if(model&&model.viewName){
                window.open(model.viewName);
            }else message.warning(Lang({id:'ZanWeiShangChuan',default: '暂未上传'}));
        }else if(res.message)message.warning(res.message);
    }
    /**
     * 设置 预览
     */
    setPicVisible(flag,current){
        this.setState({
            visible:flag,
            current:current
        })
    }
    componentDidMount() {
      if(this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { item,} = this.props;
        const {visibleModal, visible, current,list }=this.state;
        return (<Fragment>
            <Button onClick={()=>this.viewStickerPictures(item,true)}>{Lang({id: "ChaKanZhuangGuiTuPian",default: "查看装柜图片"})}</Button>

            {visibleModal&&<Modal title={Lang({id:'ChaKanZhuangGuiTuPian',default:'查看装柜图片'})}
                                  open={visibleModal}
                                  width={980}
                                  footer={null}
                                  onOk={()=>this.setVisible(false)}
                                  onCancel={()=>this.setVisible(false)}>
                <div className={'cabinetPicturePreviewWrap'}>
                    <div className={'action'}>
                    <Button type={'primary'} onClick={()=>this.downloadPic(item.containerId)}>{Lang({id: "XiaZai",default: "下载"})}</Button>
                    </div>
                    <div className={'pic'}>
                    {/*{list.map((src,i)=><Image key={i} src={src.fileUrl} preview={{ visible: false }} className={'pic'} alt={''} onClick={() => this.setPicVisible(true,i)} />)}*/}
                        <ImagePreviewGroup
                            // preview={{ visible, current, onVisibleChange: vis => this.setPicVisible(vis),mask:<>esssaone</> }}
                        >
                            {list.map((src,inx)=><Image src={src.fileUrl} key={inx} alt={'essaone.com'} preview={{mask:<EyeOutlined style={{fontSize:'16px'}} />}} />)}
                        </ImagePreviewGroup>
                    </div>
                </div>
            </Modal>}

            {/*<div style={{ display: 'none' }}>*/}
                {/*<ImagePreviewGroup preview={{ visible, current, onVisibleChange: vis => this.setPicVisible(vis) }}>*/}
                    {/*{list.map((src,inx)=><Image src={src.fileUrl} key={inx} />)}*/}
                {/*</ImagePreviewGroup>*/}
            {/*</div>*/}
        </Fragment>);
    }
}

export default CabinetPicturePreview;
